export default {
  fields: {
    country: "Bank's country",
    iban: 'IBAN',
    routing_number: 'Routing number',
    account_number: 'Account number',
    sort_code: 'Sort code',
    account_type: 'Account type',
  },
  help: {
    country: 'The country of the bank, which can differ from the restaurant’s.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code and account number',
      description: 'The usual way to enter a UK account.',
    },
    iban: {
      title: 'IBAN',
      description: 'The international bank account number.',
    },
    us_local: {
      title: 'Routing and account number',
      description: 'A US bank account.',
    },
  },
  account_types: {
    checking: 'Checking',
    savings: 'Savings',
  },
  actions: {
    save: 'Save bank account',
    cancel: 'Cancel',
    edit: 'Edit',
  },
  card: {
    account: 'Account',
    country: 'Country',
    status: 'Status',
  },
  statuses: {
    active: 'Active',
    pending_verification: 'Being verified',
    action_needed: 'Action needed',
    errored: 'Payout failed',
    missing: 'Missing',
  },
  notes: {
    pending_verification:
      'Adyen checks every bank account before payouts start. Confirm it on Adyen’s page with a bank login or a bank statement.',
    action_needed:
      'The payment provider could not confirm this bank account. Check the details or enter another account.',
    errored: 'A payout to this account failed and payouts are paused. Check the details or enter another account.',
  },
};
